import {AlertBoardRestPage} from './alert_board_types';
import {AlertEpisodeRowDto} from './alert_types';

/**
 * The alerts list (PDW-183 / FE PDW-256, BE PDW-255): a queue of patients, each with every matching episode beneath.
 * The shapes follow core's `AlertPatientListDtos.kt` and `AlertPatientEpisodeDtos.kt`, answered unchanged by the
 * product's `GET /api/alerts`.
 */

/**
 * One episode on the list: the panel's row, plus when it first opened. Since BE PDW-417 the list resolves anchors as
 * the panel does: a row whose source record is gone has no link and no actions.
 */
export type AlertListEpisodeDto = AlertEpisodeRowDto & {
  /** When the episode first opened, set once (ISO date-time). */
  firstActiveOn: string;
};

/**
 * One patient with every matching episode, in the panel's order. `totalAlertWeight` sums the weights of the matching
 * episodes that display as Active.
 */
export type AlertPatientListRowDto = {
  patientId: number;
  fullName: string | null;
  identificationNumber: string | null;
  srcId: string | null;
  totalAlertWeight: number;
  episodes: AlertListEpisodeDto[];
};

export type AlertPatientListPage = AlertBoardRestPage<AlertPatientListRowDto>;

/**
 * What the list orders whole patients by (core's `AlertPatientListSort`). Every key the request leaves out follows in
 * the default order: total alert weight descending, first active ascending, weight descending, patient ascending, then
 * the patient id.
 */
export type AlertPatientListSortProperty = 'totalAlertWeight' | 'firstActiveOn' | 'weight' | 'fullName';
export const ALERT_PATIENT_LIST_SORT_PROPERTIES: AlertPatientListSortProperty[] = [
  'totalAlertWeight',
  'firstActiveOn',
  'weight',
  'fullName',
];
/** The column the list's default order is shown on. */
export const ALERT_PATIENT_LIST_DEFAULT_SORT_PROPERTY: AlertPatientListSortProperty = 'totalAlertWeight';
